import BackButton from "components/offerings/create/BackButton";
import ButtonWrapper from "components/offerings/create/ButtonWrapper";
import InputGroup from "components/offerings/create/InputGroup";
import NextButton from "components/offerings/create/NextButton";

export function renderField(field, parentProps, settings = {}) {
  const {
    component: _FieldComponent,
    disabled,
    description,
    visible,
    ...others
  } = field;

  const { _hideError = false } = settings;

  const { formData, formErrors, onFieldChange, ...otherParentProps } =
    parentProps;

  return (
    <_FieldComponent
      onChange={onFieldChange}
      currency={formData?.currency || "INR"}
      {...others}
      {...otherParentProps}
      formData={formData}
      value={formData ? formData[others.name] : null}
      error={formErrors ? formErrors[others.name] : null}
      description={
        typeof description === "function" ? description(formData) : description
      }
      disabled={typeof disabled === "function" ? disabled(formData) : disabled}
      visible={typeof visible === "function" ? visible(formData) : visible}
      _hideError={_hideError}
    />
  );
}

export default function FormStep({ title, children }) {
  return (
    <div className="flex flex-col gap-3 p-2 my-2 h-auto w-full">
      <h3 className="text-2xl font-bold">{title}</h3>
      {children}
    </div>
  );
}

export function FormFields({ fields, ...otherParentProps }) {
  return (
    <div className="">
      {fields.map((field, idx) => {
        return (
          <div className="mb-4" key={idx}>
            {renderField(field, otherParentProps)}
          </div>
        );
      })}
    </div>
  );
}

export function ModalFormFields({ fields, ...otherParentProps }) {
  return (
    <div className="">
      {fields.map((field, idx) => {
        let component;
        const { label, showHint=false, fields: subFields } = field;

        if (subFields) {
          component = (
            <InputGroup
              label={label}
              fields={subFields}
              showHint={showHint}
              {...otherParentProps}
            />
          );
        } else {
          component = renderField(field, otherParentProps);
        }

        return (
          <div className="mb-4" key={idx}>
            {component}
          </div>
        );
      })}
    </div>
  );
}

export function FormStepControls({
  step,
  isLoading,
  goPrev,
  goNext,
  isSinglePage,
}) {
  return (
    <ButtonWrapper step={step} isSinglePage={isSinglePage}>
      {step > 0 && !isSinglePage && (
        <BackButton handleBackButton={goPrev} disabled={isLoading} />
      )}
      {(!isSinglePage || step > 0) && (
        <NextButton
          isLoading={isLoading}
          step={step}
          handleNextButton={goNext}
        />
      )}
    </ButtonWrapper>
  );
}
